import React from "react";

import { assetImg } from "@/modules/moduleImporter";
import { renderResultHistory } from "@/modules/commonPopupResultHistory";
import { IPopupResultHistoryProps } from "@/types/PopupResultHistoryTypes";

import "../index.scss";
import { getBasePcode } from "@/modules/gamePcode";

//Template: Gong Ball
//Red White
export default class M11 extends React.PureComponent<IPopupResultHistoryProps> {
	render() {
		// Template consts
		const langdata = this.props.langdata,
			  orientation = this.props.orientation;

		const basePcode = getBasePcode(this.props.activeGame.pcode);
		
		// PORTRAIT TAB NAMES
		const tabNames = ["Red & White"];

		// HEADERS
		const landscapeHeaders = [
			langdata["txt_periode"],
			langdata["txt_win"]
		];
		
		// TAB HEADER ELEMENTS
		const portraitHeaderIndices = (
			this.props.portraitTabIndex === 0 ? [0, 1] :
			null
		);
		
		// TABLE BODY
		const bodyMapFunction = (item, idx) => {
			const cells = [
				item.periode,
				item.angka.split(",").map((_item, _idx) =>
					assetImg("m11", _item, "m11_prh_" + _idx)
				)
			];


			
			//Template functions start here
			const landscapeColumns = cells.map((cell, _idx) =>
				<td key={"lC_" + _idx}>
					{cell}
				</td>
			), portraitColumns = portraitHeaderIndices.map((num, _idx) =>
				<td key={"pC_" + this.props.portraitTabIndex + _idx}>
					{ cells[num] }
				</td>
			);
		
			return (
				<tr key={"tpdhm_" + idx}>
					{
						orientation === "landscape" ?
						landscapeColumns : portraitColumns
					}
				</tr>
			);
		};
		
		

		// Template Tab Headers, no need to change
		const headers = orientation === "landscape" ?
			landscapeHeaders :
			portraitHeaderIndices.map(num => landscapeHeaders[num]);

		// Template function, no need to change
		return renderResultHistory(
			this.props.activeGame.resultHistory,
			basePcode,
			headers,
			bodyMapFunction,
			
			this.props.gameResultHistoryPage,

			this.props.fetchResultHistory,
			this.props.changePortraitResultHistoryTab,
			// null,
			
			{
				mobile: this.props.mobile,
				mobileHome: this.props.mobileHome,
				desktop: this.props.desktop,
				orientation: orientation,
				tabNames: tabNames,
				
				portraitTabIndex: this.props.portraitTabIndex,
				showGameResultHistoryLoadingOverlay: this.props.showGameResultHistoryLoadingOverlay
			}
		);
	}
}
